import React, { useState } from 'react'
import './CommonDesignGallery.css';

import diningwithcrockerydiningbench1 from '../../assets/designgallery/Dinning Rooms/diningroom_with_dining bench/diningroom_crockeryunit_dining_bench (1).avif'
import diningwithcrockerydiningbench2 from '../../assets/designgallery/Dinning Rooms/diningroom_with_dining bench/diningroom_crockeryunit_dining_bench (2).avif'
import diningwithcrockerydiningbench3 from '../../assets/designgallery/Dinning Rooms/diningroom_with_dining bench/diningroom_crockeryunit_dining_bench (3).avif'
import diningwithcrockerydiningbench4 from '../../assets/designgallery/Dinning Rooms/diningroom_with_dining bench/diningroom_crockeryunit_dining_bench (4).avif'
import diningwithcrockerydiningbench5 from '../../assets/designgallery/Dinning Rooms/diningroom_with_dining bench/diningroom_crockeryunit_dining_bench (5).avif'
import diningwithcrockerydiningbench6 from '../../assets/designgallery/Dinning Rooms/diningroom_with_dining bench/diningroom_crockeryunit_dining_bench (6).avif'

import diningroomopenkitchen1 from '../../assets/designgallery/Dinning Rooms/diningroom_openkitchen/diningroom_openkitchen (1).jpg'
import diningroomopenkitchen2 from '../../assets/designgallery/Dinning Rooms/diningroom_openkitchen/diningroom_openkitchen (2).jpg'
import diningroomopenkitchen3 from '../../assets/designgallery/Dinning Rooms/diningroom_openkitchen/diningroom_openkitchen (8).jpg'
import diningroomopenkitchen4 from '../../assets/designgallery/Dinning Rooms/diningroom_openkitchen/diningroom_openkitchen (4).jpg'
import diningroomopenkitchen5 from '../../assets/designgallery/Dinning Rooms/diningroom_openkitchen/diningroom_openkitchen (5).jpg'
import diningroomopenkitchen6 from '../../assets/designgallery/Dinning Rooms/diningroom_openkitchen/diningroom_openkitchen (6).jpg'


import traditionalvintagefurniture1 from '../../assets/designgallery/Dinning Rooms/traditionaldining_wooden_furniture/traditionaldiningroom_vintage furniture (1).jpg'
import traditionalvintagefurniture2 from '../../assets/designgallery/Dinning Rooms/traditionaldining_wooden_furniture/traditionaldiningroom_vintage furniture (2).jpg'
import traditionalvintagefurniture3 from '../../assets/designgallery/Dinning Rooms/traditionaldining_wooden_furniture/traditionaldiningroom_vintage furniture (3).jpg'
import traditionalvintagefurniture4 from '../../assets/designgallery/Dinning Rooms/traditionaldining_wooden_furniture/traditionaldiningroom_vintage furniture (4).jpg'
import traditionalvintagefurniture5 from '../../assets/designgallery/Dinning Rooms/traditionaldining_wooden_furniture/traditionaldiningroom_vintage furniture (5).jpg'
import traditionalvintagefurniture6 from '../../assets/designgallery/Dinning Rooms/traditionaldining_wooden_furniture/traditionaldiningroom_vintage furniture (6).jpg'


import industrialdiningroom1 from '../../assets/designgallery/Dinning Rooms/diningroomindustrialstyle/industrialstylediningroom, (9).jpg'
import industrialdiningroom2 from '../../assets/designgallery/Dinning Rooms/diningroomindustrialstyle/industrialstylediningroom, (6).jpg'
import industrialdiningroom3 from '../../assets/designgallery/Dinning Rooms/diningroomindustrialstyle/industrialstylediningroom, (7).jpg'
import industrialdiningroom4 from '../../assets/designgallery/Dinning Rooms/diningroomindustrialstyle/industrialstylediningroom, (8).jpg'
import industrialdiningroom5 from '../../assets/designgallery/Dinning Rooms/diningroomindustrialstyle/industrialstylediningroom, (11).jpg'
import industrialdiningroom6 from '../../assets/designgallery/Dinning Rooms/diningroomindustrialstyle/industrialstylediningroom, (3).jpg'

import diningroomwithview1 from '../../assets/designgallery/Dinning Rooms/DiningRoomWithview/diningroomwithview (1).jpg'
import diningroomwithview2 from '../../assets/designgallery/Dinning Rooms/DiningRoomWithview/diningroomwithview (2).jpg'
import diningroomwithview3 from '../../assets/designgallery/Dinning Rooms/DiningRoomWithview/diningroomwithview (8).jpg'
import diningroomwithview4 from '../../assets/designgallery/Dinning Rooms/DiningRoomWithview/diningroomwithview (4).jpg'
import diningroomwithview5 from '../../assets/designgallery/Dinning Rooms/DiningRoomWithview/diningroomwithview (5).jpg'
import diningroomwithview6 from '../../assets/designgallery/Dinning Rooms/DiningRoomWithview/diningroomwithview (6).jpg'

import { Link } from 'react-router-dom';
import { BiSolidOffer } from 'react-icons/bi';
import { MdOutlineReplay10, MdOutlineThumbUpAlt, MdOutlineThumbUpOffAlt } from 'react-icons/md';


const DiningRoom = () => {
// *****************************************
const [isExpanded1, setIsExpanded1] = useState(true);
const toggleContent1 = () => {
setIsExpanded1(prev => !prev);
};
// *****************************************
// *****************************************
const [isExpanded2, setIsExpanded2] = useState(false);
const toggleContent2 = () => {
setIsExpanded2(prev => !prev);
};
// *****************************************
  return (
    <div className=' dinning-room design-gallery'>
        <div className='dinning-room-heading container'>
            <h3>Dining Room Designs</h3>
            <p className='para'>
                Check out popular Dining Room Designs amongst our happy customers.
            </p>
        </div>
        {/* ******************************************************** */}

        <div className='shapes container'>
            {/* slider 1 */}
             <div id="carouselExampleIndicators" class="carousel slide">
                                    <div class="carousel-indicators">
                                      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    </div>
                                  <div class="carousel-inner">
                                      <div class="carousel-item active">
                                        <img src={diningwithcrockerydiningbench1} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={diningwithcrockerydiningbench2} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={diningwithcrockerydiningbench3} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={diningwithcrockerydiningbench4} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={diningwithcrockerydiningbench5} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={diningwithcrockerydiningbench6} class="d-block w-100" alt="..."/>
                                    </div>
                                  </div>
                                  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                  </button>
                                  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                  </button>
             </div>

            <div className='images-details mt-3'>
                            <p className='img-details-and-btn'> A Modern Dining Room With A Space Saving Crockery Unit Cum  Dining Bench<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                             {/* Show more button */}
                             {!isExpanded1 && (
                                <button 
                                  className='show-more btn mt-2'
                                  onClick={toggleContent1}
                                  aria-expanded={isExpanded1}
                                >
                                 Show More ▼  
                                </button>
                             )}

                             {/* Expanded content */}
                             {isExpanded1 &&(
                                <div className='extra-info mt-3'>
                                    <p className='extra-info-para'>
                                      This dining room design is for people with small homes asnit has been designed with multifunctional
                                      modular furniture. The dining table is a dark walnut wood table for six. The dinning table comes with three walnut 
                                      wood cushioned chairs and a bench sitting arrangement on the other side.
                                      The bench is attached to a large crockery unit that makes use of available space
                                      without compromising on style.
                                    </p>
                                    <p className='extra-info-features'>Special Features</p>
                                    <ul className='extra-info-list'>
                                        <li>The dark walnut wood dinning table is sleek and simple and save space.</li>
                                        <li>The dining table comes with three or more walnut woodchairs with cushions. </li>
                                        <li>The other side of the table has a bench seating arrangement with storrage beneath.</li>
                                        <li>The crockery unit is finished in white and light wood laminate. </li>
                                        <li>The crockery unit has glass fronts on one side and white handleless shutters on the other.</li>
                                        <li>The crockery unit also has small open shelf to display decor.</li>
                                        <li>Storage cabinets run along the length of the crockery unit at bottom and are designed with handleless doors for a seamles look.</li>
                                    </ul>

                                 {/* Show less button */}
                                 <button
                                  className='show-less btn  mt-3'
                                  onClick={toggleContent1}
                                  aria-expanded={isExpanded1}
                                  >
                                   Show Less ▲  
                                  </button>
                                </div>
                             )}
                            
            </div>
            {/* slider-1 end */}
            <div style={{margin:'80px'}}  ></div>



            {/* slider-2 */}
            <div id="carouselExampleIndicators1" class="carousel slide">
                                    <div class="carousel-indicators">
                                      <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    </div>
                                  <div class="carousel-inner">
                                      <div class="carousel-item active">
                                        <img src={diningroomopenkitchen1} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={diningroomopenkitchen2} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={diningroomopenkitchen3} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={diningroomopenkitchen4} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={diningroomopenkitchen5} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={diningroomopenkitchen6} class="d-block w-100" alt="..."/>
                                    </div>
                                  </div>
                                  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                  </button>
                                  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators1" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                  </button>
            </div>
            
             <div className='images-details mt-3'>
                                        <p className='img-details-and-btn'>  Modern Dining Room cum Open Kitchen Design<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                                         {/* Show more button */}
                                         {!isExpanded2 && (
                                            <button 
                                              className='show-more btn mt-2'
                                              onClick={toggleContent2}
                                              aria-expanded={isExpanded2}
                                            >
                                             Show More ▼  
                                            </button>
                                         )}
            
                                         {/* Expanded content */}
                                         {isExpanded2 &&(
                                            <div className='extra-info mt-3'>
                                                <p className='extra-info-para'>
                                                  This dining room has an edgy vibe with worn out industrial style elements. Open shelved cabinets, yellow printed wall paper,
                                                  and a wooden partition with glass together make up a complete look.
                                                </p>
                                                <p className='extra-info-features'>Special Features</p>
                                                <ul className='extra-info-list'>
                                                    <li>A modern dining area adjacent to the open kitchen to enjoy meals with friends and family.</li>
                                                    <li>A glass sliding door to bring in some natural light and fresh air.</li>
                                                    <li>A wooden table with four leather upholstered chairs for a luxurious looking setting.</li>
                                                    <li>Marble flooring makes the dining room look spacious.</li>
                                                    <li>A breakfast counter with two bar stools for additional seating separate the kitchen from the dining area</li>
                                                    <li>The breakfast counter has open shelves to display your crockeries and showpieces.</li>
                                                    <li>The floral patterned wallpaper and beautiful wall paintings make this space look stylish and chic</li>
                                                </ul>
            
                                             {/* Show less button */}
                                             <button
                                              className='show-less btn  mt-3'
                                              onClick={toggleContent2}
                                              aria-expanded={isExpanded2}
                                              >
                                               Show Less ▲  
                                              </button>
                                            </div>
                                         )}
                                        
             </div>
             {/* slider-2 end */}
            <div style={{margin:'80px'}}  ></div>
             

        </div>
        {/*whychooseourkitchen*/}
                            <div className='whyourkitchen'>
                              <h3>Why Choose Our Dining Room Designs</h3>
                              <div className='whyourkitchen-reason'>
                                <div className='icon-para-div1'>
                                    <BiSolidOffer className='icon'/>
                                    <p className='whyourkitchen-para'>20% Extra Space</p>
                                </div>
                                <div className='icon-para-div1'>
                                    <MdOutlineReplay10 className='icon'/>
                                    <p className='whyourkitchen-para'>10 Year Warranty</p>
                                </div>
                                <div className='icon-para-div1'>
                                    <MdOutlineThumbUpOffAlt  className='icon'/>
                                    <p className='whyourkitchen-para'>Installation by Professionals</p>
                                </div>
                              </div>
                            </div>
        {/*whychooseourkitchen*/}
        <div className='shapes container'>
            {/* slider-3 */}
             <div id="carouselExampleIndicators3" class="carousel slide">
                                    <div class="carousel-indicators">
                                      <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                      <button type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    </div>
                                  <div class="carousel-inner">
                                      <div class="carousel-item active">
                                        <img src={traditionalvintagefurniture1} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={traditionalvintagefurniture2} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={traditionalvintagefurniture3} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={traditionalvintagefurniture4} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={traditionalvintagefurniture5} class="d-block w-100" alt="..."/>
                                      </div>
                                      <div class="carousel-item">
                                        <img src={traditionalvintagefurniture6} class="d-block w-100" alt="..."/>
                                    </div>
                                  </div>
                                  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="prev">
                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Previous</span>
                                  </button>
                                  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators3" data-bs-slide="next">
                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span class="visually-hidden">Next</span>
                                  </button>
             </div>
             <div className='images-details mt-3'>
                                        <p className='img-details-and-btn'>  Modern Dining Room cum Open Kitchen Design<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                                         {/* Show more button */}
                                         {!isExpanded2 && (
                                            <button 
                                              className='show-more btn mt-2'
                                              onClick={toggleContent2}
                                              aria-expanded={isExpanded2}
                                            >
                                             Show More ▼  
                                            </button>
                                         )}
            
                                         {/* Expanded content */}
                                         {isExpanded2 &&(
                                            <div className='extra-info mt-3'>
                                                <p className='extra-info-para'>
                                                   This dining area is designed right beside the open plan kitchen separated by a countertop. It is a beautiful mixture of wood and white. 
                                                   Ample natural lght d the LED-lit false ceiling illuminates the room beautifully. The breakfast counter with open shelves adds to the functionality of the space.
                                                </p>
                                                <p className='extra-info-features'>Special Features</p>
                                                <ul className='extra-info-list'>
                                                    <li>A modern dining area adjacent to the open kitchen to enjoy meals with friends and family.</li>
                                                    <li>A glass sliding door to bring in some natural light and fresh air.</li>
                                                    <li>A wooden table with four leather upholstered chairs for a luxurious looking setting.</li>
                                                    <li>Marble flooring makes the dining room look spacious.</li>
                                                    <li>A breakfast counter with two bar stools for additional seating separate the kitchen from the dining area</li>
                                                    <li>The breakfast counter has open shelves to display your crockeries and showpieces.</li>
                                                    <li>The floral patterned wallpaper and beautiful wall paintings make this space look stylish and chic</li>
                                                </ul>
            
                                             {/* Show less button */}
                                             <button
                                              className='show-less btn  mt-3'
                                              onClick={toggleContent2}
                                              aria-expanded={isExpanded2}
                                              >
                                               Show Less ▲  
                                              </button>
                                            </div>
                                         )}
                                        
             </div>
            {/* slider-3 end */}
            <div style={{margin:'80px'}}  ></div>


            {/* slider-4 */}
            <div id="carouselExampleIndicators4" class="carousel slide">
                                        <div class="carousel-indicators">
                                          <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                          <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                          <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                          <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                          <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                          <button type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                        </div>
                                      <div class="carousel-inner">
                                          <div class="carousel-item active">
                                            <img src={industrialdiningroom1} class="d-block w-100" alt="..."/>
                                          </div>
                                          <div class="carousel-item">
                                            <img src={industrialdiningroom2} class="d-block w-100" alt="..."/>
                                          </div>
                                          <div class="carousel-item">
                                            <img src={industrialdiningroom3} class="d-block w-100" alt="..."/>
                                          </div>
                                          <div class="carousel-item">
                                            <img src={industrialdiningroom4} class="d-block w-100" alt="..."/>
                                          </div>
                                          <div class="carousel-item">
                                            <img src={industrialdiningroom5} class="d-block w-100" alt="..."/>
                                          </div>
                                          <div class="carousel-item">
                                            <img src={industrialdiningroom6} class="d-block w-100" alt="..."/>
                                        </div>
                                      </div>
                                      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="prev">
                                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span class="visually-hidden">Previous</span>
                                      </button>
                                      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators4" data-bs-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="visually-hidden">Next</span>
                                      </button>
            </div>

            <div className='images-details mt-3'>
                                            <p className='img-details-and-btn'> Dining Room Interior Design In Industrial Style<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                                            {/* Show more button */}
                                            {!isExpanded2 && (
                                                <button 
                                                  className='show-more btn mt-2'
                                                  onClick={toggleContent2}
                                                  aria-expanded={isExpanded2}
                                                >
                                                Show More ▼  
                                                </button>
                                            )}
                
                                            {/* Expanded content */}
                                            {isExpanded2 &&(
                                                <div className='extra-info mt-3'>
                                                    <p className='extra-info-para'>
                                                      This dinng area is designed right beside the open plan kitchen separated by a countertop. It is a beautiful mixture of wood and white. 
                                                      Ample natural lght d the LED-lit false ceiling illuminates the room beautifully. The breakfast counter with open shelves adds to the functionality of the space.
                                                    </p>
                                                    <p className='extra-info-features'>Special Features</p>
                                                    <ul className='extra-info-list'>
                                                      <li>A crockery unit with open shleves with worn laminate for an industrial look</li>
                                                      <li>A wooden partition divides the living room with dining area</li>
                                                      <li>Yellow geometric printed wallpaper adds a splash of colour to brighten up the room</li>
                                                    </ul>
                
                                                {/* Show less button */}
                                                <button
                                                  className='show-less btn  mt-3'
                                                  onClick={toggleContent2}
                                                  aria-expanded={isExpanded2}
                                                  >
                                                  Show Less ▲  
                                                  </button>
                                                </div>
                                            )}
                                            
            </div>
            {/* slider-4 end  */}
            <div style={{margin:'80px'}}  ></div>


            {/* slider-5 */}

              <div id="carouselExampleIndicators5" class="carousel slide">
                                        <div class="carousel-indicators">
                                          <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                                          <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                          <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                          <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                          <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                          <button type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                        </div>
                                      <div class="carousel-inner">
                                          <div class="carousel-item active">
                                            <img src={diningroomwithview1} class="d-block w-100" alt="..."/>
                                          </div>
                                          <div class="carousel-item">
                                            <img src={diningroomwithview2} class="d-block w-100" alt="..."/>
                                          </div>
                                          <div class="carousel-item">
                                            <img src={diningroomwithview3} class="d-block w-100" alt="..."/>
                                          </div>
                                          <div class="carousel-item">
                                            <img src={diningroomwithview4} class="d-block w-100" alt="..."/>
                                          </div>
                                          <div class="carousel-item">
                                            <img src={diningroomwithview5} class="d-block w-100" alt="..."/>
                                          </div>
                                          <div class="carousel-item">
                                            <img src={diningroomwithview6} class="d-block w-100" alt="..."/>
                                        </div>
                                      </div>
                                      <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="prev">
                                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span class="visually-hidden">Previous</span>
                                      </button>
                                      <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators5" data-bs-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="visually-hidden">Next</span>
                                      </button>
              </div>

               <div className='images-details mt-3'>
                                            <p className='img-details-and-btn'> A Modern Dining Room Design With A View<Link className='btn form-btn' to="/form">Get a Quote</Link></p>
                                            {/* Show more button */}
                                            {!isExpanded2 && (
                                                <button 
                                                  className='show-more btn mt-2'
                                                  onClick={toggleContent2}
                                                  aria-expanded={isExpanded2}
                                                >
                                                Show More ▼  
                                                </button>
                                            )}
                
                                            {/* Expanded content */}
                                            {isExpanded2 &&(
                                                <div className='extra-info mt-3'>
                                                    <p className='extra-info-para'>
                                                      A stylish dining room overlooks the view across through a window and makes for a great spot to dine at.
                                                    </p>
                                                    <p className='extra-info-features'>Special Features</p>
                                                    <ul className='extra-info-list'>
                                                     <li>A four-seater dining table.</li>
                                                     <li>Decorative pendant lights in gold make a chic statement to this space.</li>
                                                     <li>A vertical bookshelf in dark wood with glass shutters and golden rimmed handles.</li>
                                                    </ul>
                
                                                {/* Show less button */}
                                                <button
                                                  className='show-less btn  mt-3'
                                                  onClick={toggleContent2}
                                                  aria-expanded={isExpanded2}
                                                  >
                                                  Show Less ▲  
                                                  </button>
                                                </div>
                                            )}
                                            
              </div>

            {/* slider-5 end */}
            <div style={{margin:'80px'}}  ></div>





        </div>

         {/*whychooseourkitchen*/}
                            <div className='whyourkitchen'>
                              <h3>Why Choose Our Dining Room Designs</h3>
                              <div className='whyourkitchen-reason'>
                                <div className='icon-para-div1'>
                                    <BiSolidOffer className='icon'/>
                                    <p className='whyourkitchen-para'>20% Extra Space</p>
                                </div>
                                <div className='icon-para-div1'>
                                    <MdOutlineReplay10 className='icon'/>
                                    <p className='whyourkitchen-para'>10 Year Warranty</p>
                                </div>
                                <div className='icon-para-div1'>
                                    <MdOutlineThumbUpOffAlt  className='icon'/>
                                    <p className='whyourkitchen-para'>Installation by Professionals</p>
                                </div>
                              </div>
                            </div>
        {/*whychooseourkitchen*/}

        
        {/* FAQ's for dining room  design */}
       <div className=' design gallery faq'>
        <h2 className=' design faq-heading'>Frequently asked questions on Dining Room Designs</h2>
        {/* <Link to="/contactForm" classNameName="btn btn-warning">Enquiry Form</Link> */}
        <div className="container accordion accordion-flush" id="accordionFlushExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                1.What are the bst ways to design a dining room space?
              </button>
            </h2>
            <div id="flush-collapseOne" className="accordion-collapse collapse" >
              <div className="accordion-body">
                This heart of the home can be a place you show off your interior design style. Take into consideration the space, functionalities you want it to serve and then experiment with furniture, furnishings, colour palettes,
                and lighting for a perfect setting to host meals and create memories.
                Every dining room needs right sized table, with chairs that complement it, good lighting fixtures so you don’t eat in the dark, crockery unit and side cabinets to store/ display dinnerware and decor to amp up the style.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                2. which colour is best for dining room?
              </button>
            </h2>
            <div id="flush-collapseTwo" className="accordion-collapse collapse" >
              <div className="accordion-body">
                The most common colour combinations for a dining room include white and beige, grey, red and white, yellow, blue and black, purple, yellow and white, black and gold,
                muted green and orange. White and blue, crimson red and white, mauve and green.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                3.what are the best styles of interior design for dining rooms?
              </button>
            </h2>
            <div id="flush-collapseThree" className="accordion-collapse collapse" >
              <div className="accordion-body">
                 Popular styles of interior design for dining rooms include minimalistic, eclectic, rustic, industrial and Indian..
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                4.How do i choose a dining room for table for a small room?
              </button>
            </h2>
            <div id="flush-collapseFour" className="accordion-collapse collapse" >
              <div className="accordion-body">
               A newer design but one is becoming increasingly popular is the drop or foldable dining table design. This works well for tables that have to accommodate varying numbers of people from time to time. 
               Converting a four-seater to six, making it concise and small when not in use, are many options for the expandable dining table. Many homes, especially apartments, are gravitating towards them, as they work well in small homes. 
               A popular small dining table design is circular, supported by a central base. Although not seen in many homes, round tables add refined aesthetics to a place especially when designed in glass. It’s easy to seat several people, 
               fits into any kind of corner space including kitchen design with dining table and merges into the design of older homes.
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                5. How do you divide a living room and dining room?
              </button>
            </h2>
            <div id="flush-collapseFive" className="accordion-collapse collapse" >
              <div className="accordion-body">
              There are many smart design hacks you can use to separate a dining from living area. First you can add a partition or a screen. Next you can add a sectional sofa in one corner that will act as natural divider. Next you can try zooming.
              Carpets are a fool-proof way to zone areas – keeping them large ensures that furniture does not appear to float.

              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                6.What type of dining table should I get?
              </button>
            </h2>
            <div id="flush-collapseSix" className="accordion-collapse collapse" >
              <div className="accordion-body">
               The dining table you get depends largely on the dimensions on the room you are placing it in. Round or square shaped tables work best in smaller spaces. 
               You can even try a foldable or expandable dining table if you have a small apartment. For larger spaces you can try a rectangular or oval shaped table or even a large round shaped one. 
               Also, a four, six or eighter seater depends on the number of members in your family. 
               Further you can opt for metal or wooden tables or one with glass tops depending on your taste and budget..
                 
              </div>
            </div>
          </div>
        
        </div>
       </div>



  <p className='disclaimer container'>Kindly note: Product images are representative and may not reflect exact offerings. Please contact us to create a design customized for you.</p>

    </div>
  )
}

export default DiningRoom